export default __webpack_public_path__ + "47132b7817e718115da33b367ba2bf8f.svg";